import { Box, EnhancedDimension, Spinner } from '@factorialco/deprecated-design-system'

export const DefaultLoading = ({
  width,
  minWidth,
  maxWidth,
}: {
  width?: EnhancedDimension
  minWidth?: EnhancedDimension
  maxWidth?: EnhancedDimension
}) => {
  return (
    <Box
      height="s40"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      width={width}
      minWidth={minWidth}
      maxWidth={maxWidth}
      aria-label="default-loading"
    >
      <Spinner />
    </Box>
  )
}
